export const ENV = {
    localhost: 'localhost',
    int: 'int',
    stag: 'stag',
    prod: 'prod'
}
